// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"om","checkbox":"on","labelText":"oo","optText":"op"};